module.exports = __webpack_public_path__ + "static/RockoUltraFLF-50a94982be48871b59a6f69c41abdec1.ttf";